module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content modal__content-adddesigns pl30 pr30 pb20"
  }, [_c('h2', {
    staticClass: "text-size-20 text-regular mb20"
  }, [_vm._v("Let’s give our client some information")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-lighter pb20"
  }, [_c('h3', {
    staticClass: "text-size-16 text-regular mb5"
  }, [_vm._v("First design will be live in "), _c('span', {
    staticClass: "text-color-purple text-medium"
  }, [_vm._v(_vm._s(_vm.etaValue) + " hours")])]), _vm._v(" "), _c('range-slider', {
    staticClass: "mb5",
    attrs: {
      "taskId": _vm.args.taskId,
      "projectId": _vm.args.projectId,
      "value": _vm.etaValue,
      "etaType": 'estimatedTimeOfCompletion'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-space-between"
  }, _vm._l((_vm.etaRuler), function(count) {
    return _c('span', {
      staticClass: "text-size-12 text-regular"
    }, [_vm._v("\n        " + _vm._s(count) + "\n      ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-lighter pt25 pb20 mb20"
  }, [_c('h3', {
    staticClass: "text-size-16 text-regular mb5"
  }, [_vm._v("I estimate to spend "), _c('span', {
    staticClass: "text-color-purple text-medium"
  }, [_vm._v(_vm._s(_vm.etwValue) + " hours")]), _vm._v(" on this task")]), _vm._v(" "), _c('range-slider', {
    staticClass: "mb5",
    attrs: {
      "taskId": _vm.args.taskId,
      "projectId": _vm.args.projectId,
      "value": _vm.etwValue,
      "etaType": 'estimatedWork'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-space-between"
  }, _vm._l((_vm.etwRuler), function(count) {
    return _c('span', {
      staticClass: "text-size-12 text-regular"
    }, [_vm._v("\n        " + _vm._s(count) + "\n      ")])
  }), 0)], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn--block text-uppercase mb0",
    attrs: {
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": function($event) {
        return _vm.onConfirm()
      }
    }
  }, [_vm._v("Start this task")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42e2bfba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/task/modals/UpdateStatusModal.vue
// module id = 435
// module chunks = 2